// src/components/Experience.jsx
import React from 'react';

const items = [
  {
    role: 'Data Analyst Intern, Integra FEC LLC',
    period: 'August 2026 – Present',
    details: [
      'Design and code automated, scalable software pipelines using Python and SQL to efficiently scrape, collect, and process large-scale datasets.',
      'Own end-to-end workflows, performing econometric analysis and forensic investigation to identify complex fraud patterns across financial and cryptocurrency domains.'
    ]
  },
  {
    role: 'Web Developer & Data Scientist, The Boring Club at UW',
    period: 'September 2025 – Present',
    details: [
      'Investigated real-time computer vision pipelines and researched OpenCV methods for video preprocessing, focusing on ML inference optimization to improve live camera quality.',
      'Engineered front-end updates using HTML/CSS and JavaScript, managing end-to-end workflows with club leaders via GitHub Issues to deliver cohesive functionality.'
    ]
  },
  {
    role: 'Control Systems Programmer & Team Captain, Olympia Robotics Federation (FRC Team 4450)',
    period: 'February 2024 – August 2025',
    details: [
      'Developed computer vision systems and autonomous path-planning algorithms utilizing Limelight and Linux-based Orange Pi hardware, actively managing system resources and debugging hardware-software latency to reduce cycle times from 7s to 4s.',
      'Designed a Java state-machine architecture coordinating 10+ motors, 8 pneumatic pistons, and 6 sensors, operating at the hardware-software boundary to ensure seamless teleop and autonomous control.',
      'Led a 35+ member team, restructuring sub-team leadership to integrate systems software with hardware, improving reliability and completing robot design 2 weeks early.',
      'Managed programming for the USS Leviathan across 7 competitions, contributing to a top 25% performance at the FIRST World Championship.'
    ]
  },
  {
    role: 'Lead Electrical Engineer, Olympia Robotics Federation (FRC Team 4450)',
    period: 'May 2023 – June 2024',
    details: [
      'Designed and wired electrical layouts for USS ProtoStar and USS Leviathan, achieving 99% uptime across 84+ matches.'
    ]
  },
  {
    role: 'Founder, First Step Org',
    period: 'June 2023 – Present',
    details: [
      'Founded a nonprofit expanding FIRST Lego League access, personally mentoring 80+ students and raising approximately $2,000 to fund resource coordination.',
      'Coordinated outreach events and partnerships that drove community robotics engagement, contributing to the FRC team earning the 2024 Impact Award and 2025 Engineering Inspiration Award.'
    ]
  }
];

export default function Experience() {
  return (
    <section id="experience" className="py-8">
      <h2 className="text-2xl font-bold mb-4">Experience &amp; Leadership</h2>
      <ul className="space-y-6">
        {items.map((exp, i) => (
          <li key={i}>
            <h3 className="font-semibold">{exp.role}</h3>
            <span className="text-sm text-gray-600 dark:text-gray-400">
              {exp.period}
            </span>
            {exp.details && (
              <ul className="list-disc pl-5 mt-2 space-y-1 text-gray-700 dark:text-gray-300">
                {exp.details.map((bullet, j) => (
                  <li key={j} className="text-sm">{bullet}</li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}